import { Entity, WatchTower } from "@eai-toolkit-material-ui/icons";
import { Cloud, Person, Security } from "@mui/icons-material";
import type React from "react";

import type { ResourceType } from "../store/api/resourceTypes";

/** Resource type → icon + label, shared so the iconography stays consistent. */
export const RESOURCE_TYPE_ICONS: Record<ResourceType, React.ElementType> = {
  data: Entity,
  job: WatchTower,
  service: Cloud,
  account: Person,
  user: Person,
  role: Security,
};

export const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
  data: "Data",
  job: "Job",
  service: "Service",
  account: "Account",
  user: "User",
  role: "Role",
};

/**
 * Plural form, used as the fallback (non-sandbox, non-bookmarked) group
 * header when a ResourceSelector combines multiple types (e.g. user + role)
 * — each type gets its own group instead of one generic "All" bucket.
 */
export const RESOURCE_TYPE_PLURAL_LABELS: Record<ResourceType, string> = {
  data: "Data",
  job: "Jobs",
  service: "Services",
  account: "Accounts",
  user: "Users",
  role: "Roles",
};
